import reflection from "csi/reflection";
import NewFrom from "csi/table/NewFrom";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
const NewFromApparelBOMThemeController = declare([NewFrom], {
	/**
     * @override
     * Add ApparelBOMSubtype and BOMProductColors to the server operation and consume the values
	 * so they don't also get processed as ChangeAttributes by the framework
     */
	toWriterRequest() {
		const fd = this.getFormData();
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("ApparelBOMSubtype", xml.ATTR_REF, fd.getFieldValue(reflection.ATTR_SUBTYPE, true));
		call.addParameter("BOMProductColors", xml.ATTR_REFLIST, fd.getFieldValue("BOMProductColors", true));
		return call;
	},
	/**
     * @override
     * Blank out the BOMProductColors when copying from a BOM of a different Style
     */
	onFormData(fd) {
		const { m_aSources, m_urlParent } = this;
		const source = m_aSources[0];
		if (source && (source.__Parent__ !== m_urlParent)) {
			fd.setFieldInitialValue("BOMProductColors", []);
		}
		this.inherited(arguments);
	},
	/**
     * Don't allow edit of subtype if theme has BOMsubtype
     * @override
     */
	onCreatePopup(view){
		if (view.defView.getType() === "Form"){ 
			const theme = this.getParent();
			const subType = theme.ThemeBOMType;
			if (xml.isValidURL(subType)){
				view.setFieldDisabled("Subtype", true);
			}
		}
	},
	/**
     * If theme has BOMsubtype, filter only to BOM of matching subtype
     * @override
     */
	applyActionFilters(/*csi.view.Widget*/view) {
		const theme = this.getNode() || this.getParent();
		const subType = theme.ThemeBOMType;
		const query = new Query;
		query.Node("Type", xml.OP_EQUALS, "ApparelBOM");
		if (xml.isValidURL(theme.ThemeBOMType)){
			query.RefAttr("Subtype", xml.OP_EQUALS, subType);
		}
		view.relRoot.addQuery(query);           
		this.inherited(arguments);
	},
    
});
export = NewFromApparelBOMThemeController;